import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const Chart = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const token = sessionStorage.getItem("bearer_token");
  const auth_token = sessionStorage.getItem("token");

  const [dates, setDates] = useState([]);
  const [totalSalesValues, setTotalSalesValues] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Set default date range: last 7 days
  useEffect(() => {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 6);

    const formattedStart = sevenDaysAgo.toISOString().split("T")[0];
    const formattedEnd = today.toISOString().split("T")[0];

    setStartDate(formattedStart);
    setEndDate(formattedEnd);
  }, []);

  // When date range changes, fetch data
  useEffect(() => {
    if (startDate && endDate) {
      fetchAndSetData(startDate, endDate);
    }
  }, [startDate, endDate]);

  const fetchAndSetData = async (start, end) => {
    const dateArray = [];
    const currentDate = new Date(start);
    const lastDate = new Date(end);

    while (currentDate <= lastDate) {
      dateArray.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    try {
      const endpoint =
        location.pathname === "/kiosk-sales"
          ? "api/sales/week-report?kiosk=true"
          : "api/sales/week-report";

      const res = await axios.get(process.env.REACT_APP_API_URL + endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          auth_token: `${auth_token}`,
        },
        params: { startDate: start, endDate: end },
      });

      const salesDataMap = res.data.data.reduce((acc, entry) => {
        acc[entry.date] = parseFloat(entry.totalSalesValue);
        return acc;
      }, {});

      const totalSalesValuesArray = dateArray.map((date) =>
        salesDataMap[date] !== undefined ? salesDataMap[date] : 0
      );

      setDates(dateArray);
      setTotalSalesValues(totalSalesValuesArray);
    } catch (err) {
      if (err.response?.status === 400 && err.response.data === "invalid token") {
        navigate("/login");
      } else {
        console.error(err);
        setDates(dateArray);
        setTotalSalesValues(dateArray.map(() => 0));
      }
    }
  };

  const updateChart = () => {
    const options = {
      series: [
        {
          name: "Revenue",
          data: totalSalesValues,
          color: "#1A56DB",
        },
      ],
      xaxis: {
        categories: dates,
        labels: {
          style: {
            fontFamily: "Inter, sans-serif",
            cssClass: "text-xs font-normal fill-gray-500 dark:fill-gray-400",
          },
        },
      },
      yaxis: {
        min: 0,
        max: Math.max(...totalSalesValues) + 100000,
        tickAmount: 6,
        labels: {
          formatter: (value) => `${(value / 1000).toFixed(2)}K`,
        },
      },
      chart: {
        type: "area",
        height: "400",
        animations: { enabled: true },
      },
      fill: {
        type: "gradient",
        gradient: {
          opacityFrom: 0.6,
          opacityTo: 0,
          shade: "light",
          gradientToColors: ["#1C64F2"],
        },
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      grid: {
        borderColor: "#E5E7EB",
        strokeDashArray: 5,
      },
    };

    const chartElement = document.getElementById("labels-chart");
    if (chartElement) {
      chartElement.innerHTML = ""; // Clear previous chart
      const chart = new ApexCharts(chartElement, options);
      chart.render();
    }
  };

  // Update chart when data changes
  useEffect(() => {
    if (totalSalesValues.length > 0 && dates.length > 0) {
      updateChart();
    }
  }, [totalSalesValues, dates]);

  return (
    <div>
      <div className="md:flex md:m-6 my-2 md:my-0">
        <div className="md:flex items-center my-5 md:my-0">

          <label>
            Start Date:
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="mx-5 rounded-md"
          />
        </div>

        <div>
          <label className="md:ml-5 my-5 md:my-0">
            End Date:
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="mx-5 rounded-md"
          />
        </div>


      </div>

      <div id="labels-chart"></div>
    </div>
  );
};

export default Chart;
